import Spinner from "../../../Spinner";

export default function DeleteEntryButton({entry, loading, locked, lockReason}) {
	// A disabled button fires no mouse events, so the reason has to hang on a wrapper or it is
	// never readable — which would leave the contributor with a greyed-out button and no idea why.
	return (
		<span title={locked ? lockReason : undefined}>
			<button className={"btn btn-sm btn-danger"} type={"button"} disabled={loading || locked} data-bs-toggle={locked ? undefined : "modal"} data-bs-target={locked ? undefined : `#deleteEntryModal${entry.id}`}>{loading && <Spinner small={true} />} Delete</button>
		</span>
	);
}
